import api from './api';

export const getContributions = async (params) => {
  const response = await api.get('/contributions', { params });
  return response.data;
};

export const getContributionById = async (id) => {
  const response = await api.get(`/contributions/${id}`);
  return response.data;
};